import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { Select, Option } from '@sololearnorg/sol';
import useStyles from 'isomorphic-style-loader/useStyles';
import { Container } from '../../../../symphony';
import {
	getQuestionsFilerType,
	questionsFilerTypeAlias,
	SlDiscussContext,
} from '../../global-constants';
import { AskQuestion } from '../AskQuestion/AskQuestion';
import { SlActions } from '../../services/ActionsService/sl-actions';
import { ActionType, RequestType } from '../../global-interface';
import s from './QuestionsFilter.scss';

export function QuestionsFilter() {
	useStyles(s);
	const [searchParams, setSearchParams] = useSearchParams();

	const filterChangeHandler = (selectedFilter: string) => {
		const { actions$ } = Container.take(SlDiscussContext, SlActions);
		actions$.next({
			type: ActionType.QuestionFilterChange,
			requestType: RequestType.Parallel,
			data: {
				selectedFilter,
			},
		});

		searchParams.set('ordering', questionsFilerTypeAlias[selectedFilter]);
		searchParams.set('page', '1');
		setSearchParams(searchParams);
	};

	const currentValue = Object.keys(questionsFilerTypeAlias).find(
        	(key) => questionsFilerTypeAlias[key] === searchParams.get('ordering'),
	) || Object.keys(getQuestionsFilerType())[0];

	return (
		<div className="discuss-questions-filter">
			<Select
				name="question-filter"
				value={currentValue}
				className="discuss-questions-filter__sort"
				onValueChange={filterChangeHandler}
				size="m"
			>
				{Object.keys(getQuestionsFilerType()).map((typeKey) => (
					<Option value={typeKey} key={typeKey}>
						{getQuestionsFilerType()[typeKey]}
					</Option>
				))}
			</Select>
			<Select
				name="question-filter-mobile"
				value={currentValue}
				className="discuss-questions-filter__sort__small"
				onValueChange={filterChangeHandler}
				size="s"
			>
				{Object.keys(getQuestionsFilerType()).map((typeKey) => (
					<Option value={typeKey} key={typeKey}>
						{getQuestionsFilerType()[typeKey]}
					</Option>
				))}
			</Select>
			<AskQuestion />
		</div>
	);
}
